import { Avatar, Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import crmConnectorsApi from "../../../api/crmConnectorsApi";
import { useCrmConnectorContext } from "./CrmConectorContext";

interface Props {
  open: boolean;
  onSuccess: () => void;
  onCancel: () => void;
}

const DeleteConnectionDialog = ({ open, onSuccess, onCancel }: Props) => {
  const [apiError, setApiError] = useState<string>();

  const { crmName, crmApiName, logoSrc } = useCrmConnectorContext();

  const handleCancel = () => {
    setApiError(undefined);
    onCancel();
  };

  const handleDeleteClick = async () => {
    setApiError(undefined);

    const [, error] = await withErrorHandling(crmConnectorsApi[crmApiName].deleteConnection)();
    if (error) {
      setApiError(error.message);
      return;
    }

    onSuccess();
  };

  return (
    <SmallDialog open={open} onClose={handleCancel}>
      <DialogTitle>Delete Connection</DialogTitle>
      <DialogCloseButton onClick={handleCancel} />
      <DialogContent sx={{ px: 8 }}>
        <Stack sx={{ my: 2, alignItems: "center" }}>
          <Avatar src={logoSrc} variant="square" alt="logo" sx={{ width: 80, height: 80 }} />
          <Typography variant="subtitle1">{crmName}</Typography>
        </Stack>
        <Typography sx={{ textAlign: "center" }}>Are you sure you want to delete the connection?</Typography>
        {apiError && (
          <Typography
            sx={[{ textAlign: "center" }, (theme) => ({ color: theme.palette.error.main, mt: theme.spacing(1) })]}
          >
            {apiError}
          </Typography>
        )}
      </DialogContent>
      <DialogButtons onCancel={handleCancel}>
        <Button variant="outlined" color="error" onClick={handleDeleteClick}>
          Delete
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default DeleteConnectionDialog;
